
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5f97f1b3&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./couponAdd.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./couponAdd.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5f97f1b3!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./couponAdd.vue"),
  /* scopeId */
  "data-v-5f97f1b3",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/operationManagement/couponAdd.vue
// module id = 1518
// module chunks = 3